if (!customElements.get('g-referral-img')) {
  class Referral extends HTMLElement {
    constructor() {
      super();
      this.langObj = {};
      this.selectors = {
        modalOne: '#addOrderModal',
        modalTwo: '#addOrderModal2',
        openBtn: '.js_open_modal',
        copyBtn: '.js-copy',
        facebookDom: '.g-facebook',
        twitterDom: '.g-twitter',
        whatsappDom: '.g-whatsapp',
        instagramDom: '.g-instagram',
        inputDom: '.js_input',
        inputDom2: '.js_input2',
        inputDom3: '.js_input3',
        referredBtn: '.js-referred',
        errorDom: '.form-error',
        copyAndUseBtn: '.js-copy-use',
        referredEmail: '.referred-email',
        referredNext: '.referred-next',
        inputName: '.js_input_name',
        inputEmail: '.js_input_email',
        validateError: '.from-validate-error',
      };
      this.isLogin = !!this.dataset.isLogin;
      this.langObj.copy = this.dataset.langCopy;
      this.langObj.copied = this.dataset.langCopied;
      this.langObj.emailRequired = this.dataset.langEmailRequired;
      this.langObj.invalidEmail = this.dataset.langInvalidEmail;
      this.domNodes = queryDomNodes(this.selectors, this);
      this.email = this.domNodes.inputEmail.value;
    }

    connectedCallback() {
      this.init();
    }

    init() {
      this.openRefedModal();
      this.initEvent();
    }
    openRefedModal() {
      let code = new URLSearchParams(window.location.search).get('ic');
      this.code = code;
      if (!code) return;
      setTimeout(() => {
        this.domNodes.modalTwo?.open();
      });
    }
    initRenderCode(code) {
      const url = `${GkifySettings.base_url}pages/referral?ic=${code}`;
      const shareMap = {
        facebook: `https://www.facebook.com/sharer/sharer.php?u=${url}`,
        twitter: `https://twitter.com/intent/tweet?url=${url}`,
        whatsapp: `https://api.whatsapp.com/send?text=${url}`,
        instagram: `https://instagram.com`,
      };
      this.domNodes.facebookDom.href = shareMap.facebook;
      this.domNodes.twitterDom.href = shareMap.twitter;
      this.domNodes.whatsappDom.href = shareMap.whatsapp;
      this.domNodes.instagramDom.href = shareMap.instagram;
      this.domNodes.inputDom.value = url;
      this.domNodes.copyBtn.dataset.link = url;
    }
    initEvent() {
      this.domNodes.openBtn.addEventListener('click', this.openReferModal.bind(this));
      this.domNodes.copyBtn.addEventListener('click', this.copyLink.bind(this));
      this.domNodes.referredBtn.addEventListener('click', this.referred.bind(this));
      this.domNodes.copyAndUseBtn.addEventListener('click', this.copyAndUse.bind(this));
    }
    async copyAndUse() {
      this.domNodes.modalTwo.close();
    }
    copyLink() {
      const link = this.domNodes.copyBtn.dataset.link;
      this.handleCopy(link, this.domNodes.copyBtn);
    }
    isValidEmail(email) {
      return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
    }
    async referred() {
      let email = this.domNodes.inputDom2.value;
      if (!email) {
        GkifyTheme.Notification.show({
          target: this.domNodes.errorDom,
          method: 'appendChild',
          type: 'error',
          message: this.langObj.emailRequired,
        });
        return;
      }
      if (!this.isValidEmail(email)) {
        GkifyTheme.Notification.show({
          target: this.domNodes.errorDom,
          method: 'appendChild',
          type: 'error',
          message: this.langObj.invalidEmail,
        });
        return;
      }
      this.domNodes.referredBtn.classList.add('g-button--loading');
      try {
        let res = await fetch(`/apps/esrvip/login/sample/register-and-login`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            email,
            invited: this.code,
            finalSuccessUrl: GkifySettings.base_url,
          }),
        });
        res = await res.json();
        if (res.code == 200) {
          this.data = res.data;
          // if (!this.data.addBeInvitedCustomerDiscountCode) {
          // this.error('The invitation code is empty, please contact the administrator');
          // return;
          // }
          // this.domNodes.inputDom3.value = this.data.addBeInvitedCustomerDiscountCode;
          this.domNodes.referredEmail.classList.add('g:hidden');
          this.domNodes.referredNext.classList.remove('g:hidden');
        } else {
          this.error(res.message || 'create fail');
        }
      } catch (error) {
        this.error(error.message);
        console.log(error);
      } finally {
        this.domNodes.referredBtn.classList.remove('g-button--loading');
      }
    }
    error(content) {
      GkifyTheme.Notification.show({
        target: document.body,
        method: 'appendChild',
        type: 'error',
        message: content,
        sticky: true,
      });
    }
    async openReferModal() {
      console.log('this.email', this.email);
      let name = this.domNodes.inputName.value;
      let email = this.domNodes.inputEmail.value;
      if (!name) {
        GkifyTheme.Notification.show({
          target: this.domNodes.validateError,
          method: 'appendChild',
          type: 'error',
          message: 'Field is not empty',
        });
        return;
      }
      if (!email) {
        GkifyTheme.Notification.show({
          target: this.domNodes.validateError,
          method: 'appendChild',
          type: 'error',
          message: this.langObj.emailRequired,
        });
        return;
      }
      if (!this.isValidEmail(email)) {
        GkifyTheme.Notification.show({
          target: this.domNodes.validateError,
          method: 'appendChild',
          type: 'error',
          message: this.langObj.invalidEmail,
        });
        return;
      }
      //根据输入框去查询
      if (this.isLogin && this.email === email) {
        let refereeDom = document.querySelector('.js_referee_code');
        let code = refereeDom.dataset.code;
        this.initRenderCode(code);
        this.domNodes.modalOne.open();
        return;
      }

      this.domNodes.openBtn.classList.add('g-button--loading');
      try {
        let res = await fetch(`/apps/esrvip/vip/no-login/ref-url?email=${email}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
          },
        });
        res = await res.json();
        if (res.code == 200) {
          this.initRenderCode(res.data.code);
          this.domNodes.modalOne.open();
        } else {
          this.error(res.message);
        }
      } catch (error) {
        this.error(error.message);
        console.log(error);
      } finally {
        this.domNodes.openBtn.classList.remove('g-button--loading');
      }
    }
    async handleCopy(code, button) {
      try {
        await navigator.clipboard.writeText(code);
        // 更新按钮文本
        const originalText = button.textContent;
        button.textContent = this.langObj.copied;

        // 2秒后恢复原始文本
        setTimeout(() => {
          button.textContent = originalText;
        }, 2000);
      } catch (err) {
        console.error('Failed to copy:', err);
      }
    }
  }
  customElements.define('g-referral-img', Referral);
}
